import _ from 'lodash'
import { isEmpty } from './generalUtils'
import { pastScheduledProperties } from './routeUtils'
import { activeRouteHomeIds } from '../services/routeService'

export const getWantNeedMatch = (home, column) => {
  let type = 0
  let typeTotal = 0

  if (home.feedback.match) {
    const feedbackWantNeedList = home.feedback.match.results

    feedbackWantNeedList.forEach(item => {
      if (column === 'need') {
        type += item.wantNeed === 'Need' && item.match
        typeTotal += item.wantNeed === 'Need'
      } else {
        type += item.wantNeed === 'Want' && item.match
        typeTotal += item.wantNeed === 'Want'
      }
    })
    const percentage = (type / typeTotal) * 100
    return percentage.toFixed(2).toString()
  }
  return '0'
}

export const getPropertyKeyValue = (
  propertyId,
  propertiesList,
  requiredKey
) => {
  if (propertiesList) {
    const searchedProperty = propertiesList.find(
      property => property._id === propertyId
    )
    if (searchedProperty) {
      if (!requiredKey) return searchedProperty
      if (requiredKey === 'Images') {
        return getPropertyImage(searchedProperty)
      } else {
        return searchedProperty[requiredKey]
      }
    }
  }
  return 'Loading ' + requiredKey + '...'
}

export const getPropertyImage = propertyObject => {
  if (propertyObject.Media && propertyObject.Media.length > 0) {
    // Certain MLS can include PDF and other content
    const visibleImage = propertyObject.Media.find(m => !/(pdf)$/i.test(m.MediaURL))
    if (visibleImage) {
      // console.log(`thumbnail: ${visibleImage.MediaURL}`)
      return visibleImage.MediaURL
    }
  }
  return '/img/gradient-image-loader.png'
}

export const calculateFeedbackMatch = feedbackMatch => {
  // This condition might change later based on feedback object model
  // and schedulings array update in the API
  if (feedbackMatch) {
    if (feedbackMatch.results && feedbackMatch.results.length > 0) {
      const feedbackWantNeedList = feedbackMatch.results
      let type = 0
      let typeTotal = 0
      feedbackWantNeedList.forEach(item => {
        const points = item.wantNeed === 'Need' ? 1 : 1
        type += item.match ? points : 0
        typeTotal += points
      })
      if (typeTotal !== 0) {
        const percentage = (type / typeTotal) * 100
        return percentage.toFixed(2).toString()
      }
    }
  }
  return null
}

export const getFavoriteObjectFromPropertyId = (clientHomes, propertyId) => {
  if (clientHomes.length > 0) {
    return clientHomes.find(home => home.propertyId === propertyId)
  }
  return null
}

export const getClientFavFromPropertyId = (clientFavs, propertyId) => {
  return clientFavs.find(fav => fav._id === propertyId)
}

export const feedbackProvidedProperties = properties => {
  if (!isEmpty(properties)) {
    return properties.filter(home => feedbackProvidedProperty(home))
  }
  return []
}

export const feedbackProvidedProperty = property => {
  return (
    !isEmpty(property.feedback) &&
    property.feedback.match &&
    property.feedback.match._creator
  )
}

export const feedbackNeededProperties = (properties, routes) => {
  const viewedPropertyIds = pastScheduledProperties(routes)
  const emptyFeedbackHomes = properties.filter(property =>
    viewedPropertyIds.includes(property.propertyId)
  )
  return emptyFeedbackHomes.filter(home => {
    if (isEmpty(home.feedback)) return true
    if (home.feedback.match && !home.feedback.match._creator) {
      return true
    }
    return !home.feedback.match
  })
}

/**
 * Function to return full address of a property
 */
export const propertyFullAddress = property => {
  if (property) {
    return `${property.Address} ${property.City}, ${property.StateOrProvince} ${property.PostalCode}`
  }
  return null
}

export const roundOffMinutes = (interval, momentTime) => {
  const roundedMinutes = Math.ceil(momentTime.minute() / interval) * interval
  let optimizedTime = momentTime
    .clone()
    .minute(roundedMinutes)
    .second(0)
    .utc()
    .format()
  return optimizedTime
}

export const mlsCondition = value => {
  return !isNaN(value) && value.length > 5 && value.length < 8
}

export const splitSemiColonString = value => {
  return value
    .split(';')
    .filter(input => !isEmpty(input))
    .map(input => input.trim())
}

export const getPropertyMsgIdArray = msgList => {
  return msgList.map(
    msg =>
      msg.metadata && msg.metadata.data && msg.metadata.data.thread.property_id
  )
}

export const isOfferMade = property => {
  return !isEmpty(property) && !isEmpty(property.offerMade)
}

export const isPropertyAClientFavorite = (property, clientFavs) => {
  return !isEmpty(clientFavs)
    ? clientFavs.some(fav => fav._id === property._id)
    : false
}

// function to return sorted property list based on request tour timestamp
// also considers whether it exists or not
export const sortByRequestedTourTimestamp = (
  clientData,
  propertiesList,
  disableSort,
  sortedIds
) => {
  if (!isEmpty(propertiesList)) {
    const homeIds = activeRouteHomeIds(clientData)

    if (disableSort) {
      const groupedProperties = _.groupBy(propertiesList, property => {
        return sortedIds.includes(property._id)
      })
      return {
        properties: [
          ...(groupedProperties['false'] || []).filter(item => {
            if (item.requestTour === true || homeIds.includes(item._id)) {
              return (
                new Date(item.requestTourTimestamp) >
                new Date(clientData.lastActivity)
              )
            }
            return true
          }),
          ...(groupedProperties['true'] || [])
        ]
      }
    } else {
      const groupedProperties = _.groupBy(propertiesList, property => {
        return homeIds.includes(property._id) || property.requestTour === true
      })

      const sortedRequestedProperties = [...(groupedProperties['true'] || [])]
        .sort((a, b) => {
          if (!a.requestTourTimestamp) return 1
          if (!b.requestTourTimestamp) return -1
          return (
            new Date(b.requestTourTimestamp) - new Date(a.requestTourTimestamp)
          )
        })
        .filter(
          item =>
            new Date(item.requestTourTimestamp) >
            new Date(clientData.lastActivity)
        )
      return {
        properties: [
          ...(groupedProperties['false'] || []),
          ...(sortedRequestedProperties || [])
        ],
        sortedProperties: [...(sortedRequestedProperties || [])]
      }
    }
  }
  return []
}
